module.exports = __webpack_public_path__ + "static/unhcr-logo-975eac99d9141e6bf117d7f66d767339.png";